import React, { Component } from 'react'

import getPreSignedURLForImageService from '../../Services/Queries/getPreSignedURLForImageService'

import ImageOptions from './ImageOptions'
import { KTColors } from '../Constants/KTColors'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import AnswersInfo from './AnswersInfo'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { Modal, Button } from 'react-bootstrap'
import CreateDynamicButton from './CreateDynamicButton'
import CreateMultiDynamicButtons from './CreateMultiDynamicButtons'
import CompressContentImage from '../../Services/Mutations/compressContentImage'

class McqContent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			cropImage1: false,
			cropImage2: false,
			mcqCardCroppedImage: '',

			mcqCroppedImage: '',

			mcqTitle: '',
			answerExplanation: '',
			textColorOptions: [
				{ item: 'white', id: 1, value: KTColors.white },
				{ item: 'black', id: 2, value: KTColors.black },
				{ item: 'grey', id: 3, value: KTColors.grey400 },
			],
			selectedTextColorOption: KTColors.white,
			titleOptionsVisibility: false,
			crop: false,
			imageFor: '',
			callPermissions: 'initial',
			mcqImages: [],
			mcqCardImages: [],
			answersInfo: [],
			subContentExpanded: true,
			expandedImage: null,
			expanded: true,
			urlType: 'Instagram',
			watchType: 'Off',
			instagramLink: '',
			youtubeLink: '',
			twitterLink: '',
			websiteLink: '',
			explanationCardTitle: '',
			src: null,

			crop: {
				unit: '%',
				width: 30,
				aspect: 9 / 16,
			},
			src2: null,
			crop2: {
				unit: '%',
				width: 30,
				aspect: 16 / 9,
			},
			imageSizeLimit: 900,
			contentNewLinkDetails: {},
			imageSizeLimitModal: false,
		}
	}
	handleTitle = (e) => {
		const title = e.target.value
		this.setState({ mcqTitle: title })
		this.props.updateInParent(`mcqTitle_${this.props.contentSelectedLangVal}`, title, 'Mcq')
	}

	handleExplanationTitle = (e) => {
		const expTitle = e.target.value
		this.setState({ explanationCardTitle: expTitle })
		this.props.updateInParent(
			`explanationCardTitle_${this.props.contentSelectedLangVal}`,
			expTitle,
			'Mcq'
		)
	}
	handleAnswerExplanation = (e) => {
		const explanation = e.target.value
		this.setState({ answerExplanation: explanation })
		this.props.updateInParent(
			`answerExplanation_${this.props.contentSelectedLangVal}`,
			explanation,
			'Mcq'
		)
	}
	hastitleError = () => {
		return !this.state.mcqTitle
	}
	hasAnswerExplanationError = () => {
		return !this.state.answerExplanation
	}
	hasMcqImageError = () => {
		return !this.state.mcqImages.length
	}
	hasMcqCardImageError = () => {
		return !this.state.mcqCardImages.length
	}

	updateAnswersInfo = (answersInfo) => {
		this.setState({ answersInfo: answersInfo })
		this.props.updateInParent('answersInfo', answersInfo, 'Mcq')
	}

	handleTextColorRadioButton = (item) => {
		this.setState({ selectedTextColorOption: item.value })
		this.props.updateInParent('textColor', item.value, 'Mcq')
	}
	updatecontentLinkDetails = () => {
		const linkInput = {
			watchType: this.state.watchType,
			instagramLink: this.state.instagramLink,
			youtubeLink: this.state.youtubeLink,
			twitterLink: this.state.twitterLink,
			websiteLink: this.state.websiteLink,
		}

		if (this.state.watchType == 'watchVideo') {
			linkInput.urlType = this.state.urlType
		}
		if (this.state.watchType == 'visitWebsite') {
			linkInput.urlType = 'website'
		}

		this.props.updateInParent('contentLinkDetails', linkInput, 'Mcq')
	}

	handleMcqCardImages = (images) => {
		const imagesArr = []
		images.filter((item) => {
			const obj = {
				image: item.key ? item.key : item.image,
				copyRight: item.copyRight,
				copyRightText: item.copyRightText,
				shareImage: item.shareImage,
			}
			imagesArr.push(obj)
		})
		this.setState({
			mcqCardImages: images,
		})
		this.props.updateInParent('mcqCardImages', imagesArr, 'Mcq')
		this.props.updateInParent('mcqOriginalCardImages', images, 'Mcq')
	}
	handleMcqImages = (images) => {
		const imagesArr = []
		images.filter((item) => {
			const obj = {
				image: item.key ? item.key : item.image,
				copyRight: item.copyRight,
				copyRightText: item.copyRightText,
				shareImage: item.shareImage,
			}
			imagesArr.push(obj)
		})
		this.setState({
			mcqImages: images,
		})
		this.props.updateInParent('mcqImages', imagesArr, 'Mcq')
		this.props.updateInParent('mcqOriginalImages', images, 'Mcq')
	}

	updatecontentNewLinkDetails = (linkInput) => {
		linkInput.map((buttonObj) => {
			if (buttonObj.category == 'socialMedia') {
				const input = {
					instagramLink: buttonObj.instagramLink,
					youtubeLink: buttonObj.youtubeLink,
					twitterLink: buttonObj.twitterLink,
					websiteLink: '',
					urlType: buttonObj.urlType?.replace('Link', ''),
					watchType: 'watchVideo',
				}
				this.props.updateInParent('contentLinkDetails', input, 'Mcq')
			} else {
				this.props.updateInParent('contentLinkDetails', {}, 'Mcq')
			}
		})
		this.props.updateInParent('contentNewLinkDetails', linkInput, 'Mcq')
	}

	handleWatchType = (value) => {
		if (this.state.watchType != value) {
			this.setState(
				{
					watchType: value,
					urlType: 'Instagram',
					instagramLink: '',
					youtubeLink: '',
					twitterLink: '',
					websiteLink: '',
				},
				() => {
					this.updatecontentLinkDetails()
				}
			)
		}
	}
	handleUrlType = (value) => {
		this.setState({ urlType: value, instagramLink: '', youtubeLink: '', twitterLink: '' }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handleinstagramLink = (e) => {
		const link = e.target.value
		this.setState({ instagramLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handleinstagramLinkError = () => {
		return !this.state.instagramLink != ''
	}
	handleyoutubeLink = (e) => {
		const link = e.target.value

		this.setState({ youtubeLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handleyoutubeLinkError = () => {
		return !this.state.youtubeLink != ''
	}
	handletwitterLink = (e) => {
		const link = e.target.value

		this.setState({ twitterLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handletwitterLinkError = () => {
		return !this.state.twitterLink != ''
	}
	handlewebsiteLink = (e) => {
		const link = e.target.value

		this.setState({ websiteLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}
	handlewebsiteLinkError = () => {
		return !this.state.websiteLink != ''
	}
	toggleCopyRightSwitch = (key, fullImage) => {
		const { mcqImages, mcqCardImages } = this.state
		if (fullImage) {
			if (this.props.editContent) {
				mcqImages.filter((item) => {
					if ((item.path && item.path == key) || item.image == key) {
						item.copyRight = !item.copyRight
					}
				})
			} else {
				mcqImages.filter((item) => {
					if (item.key == key) {
						item.copyRight = !item.copyRight
					}
				})
			}
			this.handleMcqImages(mcqImages)
		} else {
			if (this.props.editContent) {
				mcqCardImages.filter((item) => {
					if ((item.path && item.path == key) || item.image == key) {
						item.copyRight = !item.copyRight
					}
				})
			} else {
				mcqCardImages.filter((item) => {
					if (item.key == key) {
						item.copyRight = !item.copyRight
					}
				})
			}
			this.handleMcqCardImages(mcqCardImages)
		}
	}
	handleCopyrightText = (key, e, fullImage) => {
		const text = e.target.value
		const { mcqImages, mcqCardImages } = this.state
		if (fullImage) {
			mcqImages.filter((item) => {
				if (item.key == key) {
					item.copyRightText = text
				}
			})
			this.handleMcqImages(mcqImages)
		} else {
			mcqCardImages.filter((item) => {
				if (item.key == key) {
					item.copyRightText = text
				}
			})
			this.handleMcqCardImages(mcqCardImages)
		}
	}

	handleCopyrightType = (key, copyrightPrefix, fullImage) => {
		const { mcqImages, mcqCardImages } = this.state
		if (fullImage) {
			mcqImages.filter((item) => {
				if (item.key == key) {
					item.copyRightText = copyrightPrefix
				}
			})
			this.handleMcqImages(mcqImages)
		} else {
			mcqCardImages.filter((item) => {
				if (item.key == key) {
					item.copyRightText = copyrightPrefix
				}
			})
			this.handleMcqCardImages(mcqCardImages)
		}
	}

	toggleShareImageSwitch = (key, fullImage) => {
		const { mcqImages, mcqCardImages } = this.state
		if (fullImage) {
			if (this.props.editContent) {
				mcqImages.filter((item) => {
					if (item.path == key || item.image == key) {
						item.shareImage = !item.shareImage
					}
				})
			} else {
				mcqImages.filter((item) => {
					if (item.key == key) {
						item.shareImage = !item.shareImage
					}
				})
			}
			this.handleMcqImages(mcqImages)
		} else {
			if (this.props.editContent) {
				mcqCardImages.filter((item) => {
					if (item.path == key || item.image == key) {
						item.shareImage = !item.shareImage
					}
				})
			} else {
				mcqCardImages.filter((item) => {
					if (item.key == key) {
						item.shareImage = !item.shareImage
					}
				})
			}
			this.handleMcqCardImages(mcqCardImages)
		}
	}
	removeMcqCardImages = (imageIndex) => {
		const images = this.state.mcqCardImages
		images.splice(imageIndex, 1)
		this.handleMcqCardImages(images)
	}
	removeMcqImages = (imageIndex) => {
		const images = this.state.mcqImages
		images.splice(imageIndex, 1)
		this.handleMcqImages(images)
	}
	handlePressImageList = (key) => {
		this.setState({
			expandedImage: key,
		})
		if (key == this.state.expandedImage) {
			this.setState({ expanded: !this.state.expanded })
		} else {
			this.setState({ expanded: true })
		}
	}

	uploadImage = (imageFor, e) => {
		this.setState(
			{
				imageFor: imageFor,
			},
			() => {
				// const { files } = this.state
				// files.push(...e.target.files)
				const files = e.target.files
				e.preventDefault()

				for (let i = 0; i < files.length; i++) {
					let file = files[i]

					let reader = new FileReader()
					reader.onloadend = async () => {
						const randomId = await uuidv4()
						const key = 'public/' + this.GetDate() + '/contents/' + randomId
						const params = {
							key: key,
							mimeType: file.type,
						}
						const preSignedURLObject = await getPreSignedURLForImageService(params)
						const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
						const signedURL = signedURLObject.data['url']
						try {
							const formData = new FormData()
							Object.keys(signedURLObject.data.fields).forEach((key) => {
								formData.append(key, signedURLObject.data.fields[key])
							})
							// Actual file has to be appended last.
							formData.append('file', file)

							const response = await axios({
								method: 'post',
								url: signedURL,
								data: formData,
								headers: { 'Content-Type': 'multipart/form-data' },
							})
							if (response.status) {
								const imageObj = {
									key: key,
									imageValue: reader.result,
									copyRight: false,
									copyRightText: '',
									shareImage: false,
								}
								this.uploadImages(imageFor, imageObj)
							}
						} catch (err) {
							console.warn(err, 'err')
						}
					}
					reader.readAsDataURL(file)
				}
			}
		)
	}
	GetDate = () => {
		return (
			new Date().getFullYear() +
			'' +
			('0' + (new Date().getMonth() + 1)).slice(-2) +
			('0' + new Date().getDate()).slice(-2)
		)
	}
	uploadImages = (imageFor, imageObj) => {
		const { mcqImages, mcqCardImages } = this.state
		if (imageFor == 'mcqImages') {
			mcqImages.push(imageObj)
			this.handleMcqImages(mcqImages)
		} else {
			mcqCardImages.push(imageObj)
			this.handleMcqCardImages(mcqCardImages)
		}
	}

	removeSelectedImage = (imageFor) => {
		if (imageFor == 'mcqImages') {
			this.setState({
				cropImage1: false,
				src: null,
				mcqImages: [],
				crop: {
					unit: '%',
					width: 30,
					aspect: 9 / 16,
				},
				croppedImageUrl: '',
				selectedMcqImage: '',
			})
			this.props.updateInParent('mcqImages', [], 'Mcq')
			this.props.updateInParent('mcqOriginalImages', [], 'Mcq')
		} else {
			this.setState({
				cropImage2: false,
				src2: '',
				mcqCardImages: [],
				crop2: {
					unit: '%',
					width: 30,
					aspect: 16 / 9,
				},
				croppedImageUrl2: '',
				selectedMcqImage: '',

				mcqCardImages: [],
				mcqCardImagesSrc: null,
				mcqCardImagesCrop: false,
				mcqCardImagesCroppedUrl: '',
				selectedMcqCardImage: '',
			})
			this.props.updateInParent('mcqCardImages', [], 'Mcq')
			this.props.updateInParent('mcqOriginalCardImages', [], 'Mcq')
		}
	}
	uploadSelectedImage = async (imageFor, crop) => {
		const randomId = await uuidv4()
		const key = 'public/' + this.GetDate() + '/contents/' + randomId
		const params = {
			key: key,
			mimeType:
				imageFor == 'mcqImages'
					? this.state.selectedMcqImage.type
					: this.state.selectedMcqCardImage.type,
		}
		const preSignedURLObject = await getPreSignedURLForImageService(params)
		const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
		const signedURL = signedURLObject.data['url']
		try {
			const formData = new FormData()
			Object.keys(signedURLObject.data.fields).forEach((key) => {
				formData.append(key, signedURLObject.data.fields[key])
			})
			const croppedFile =
				this.state.imageFor == 'mcqImages'
					? this.state.mcqCroppedImage
					: this.state.mcqCardCroppedImage
			const originalFile =
				this.state.imageFor == 'mcqImages'
					? this.state.selectedMcqImage
					: this.state.selectedMcqCardImage
			// Actual file has to be appended last.
			if (crop) {
				formData.append('file', croppedFile)
			} else {
				formData.append('file', originalFile)
			}
			const response = await axios({
				method: 'post',
				url: signedURL,
				data: formData,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			let selectedImageValue = ''
			if (this.state.imageFor == 'mcqImages') {
				selectedImageValue = this.state.mcqImagesCroppedUrl
					? this.state.mcqImagesCroppedUrl
					: this.state.src
			} else {
				selectedImageValue = this.state.mcqCardImagesCroppedUrl
					? this.state.mcqCardImagesCroppedUrl
					: this.state.mcqCardImagesSrc
			}

			if (response.status) {
				const imageObj = {
					imageValue: selectedImageValue,
					key: key,
					copyRight: false,
					copyRightText: '',
					shareImage: false,
				}
				const input = {
					imagePath: imageObj.key
				}
				console.log(input, "===========compressImageinput")
				if (input != undefined && input != null && input.imagePath != null && input.imagePath != undefined && input.imagePath != "") {
					const response = await CompressContentImage(input)
					console.log(response, "response compress image ==========")
				}
				this.uploadImages(imageFor, imageObj)
			}
		} catch (err) {
			console.warn(err, 'err')
		}
	}
	// hideImageSizeLimitModal = () => {
	// 	this.setState({
	// 		imageSizeLimitModal: false,
	// 	})
	// }
	onSelectFile = (e) => {
		let pngImageExists = false
		pngImageExists = e?.target?.files[0]?.type?.includes('png')
		if (!pngImageExists) {
			this.setState({ imageFor: 'mcqImages' })
			if (e.target.files && e.target.files.length > 0) {
				const reader = new FileReader()
				reader.addEventListener('load', () => this.setState({ src: reader.result }))
				reader.readAsDataURL(e.target.files[0])
				this.setState({
					cropImage1: false,
					imageSizeLimitModal: false,
					mcqImages: [],
					selectedMcqImage: e.target.files[0],
					// crop: false,
					croppedImageUrl: '',
					mcqCroppedImage: '',
				})
			}
		} else {
			this.setState({
				imageSizeLimitModal: true,
			})
		}
	}
	onSelectFile2 = (e) => {
		let pngImageExists = false
		pngImageExists = e?.target?.files[0]?.type?.includes('png')
		if (!pngImageExists) {
			this.setState({ imageFor: 'mcqCardImages' })
			if (e.target.files && e.target.files.length > 0) {
				const reader = new FileReader()
				reader.addEventListener('load', () => this.setState({ src2: reader.result }))
				reader.readAsDataURL(e.target.files[0])
				this.setState({
					cropImage2: false,
					mcqCardImages: [],
					selectedMcqCardImage: e.target.files[0],
					// crop2: false,
					croppedImageUrl2: '',
					mcqCardCroppedImage: '',
				})
			}
		} else {
			this.setState({
				imageSizeLimitModal: true,
			})
		}
	}

	// If you setState the crop in here you should return false.
	onImageLoaded = (image) => {
		this.imageRef = image
	}

	onCropComplete = (crop) => {
		this.makeClientCrop(crop)
	}

	onCropChange = (crop, percentCrop) => {
		// You could also use percentCrop:
		// this.setState({ crop: percentCrop });
		this.setState({ crop })
	}
	onImageLoaded2 = (image) => {
		this.imageRef2 = image
	}

	onCropComplete2 = (crop) => {
		this.makeClientCrop2(crop)
	}

	onCropChange2 = (crop, percentCrop) => {
		// You could also use percentCrop:
		// this.setState({ crop: percentCrop });
		this.setState({ crop2: crop })
	}

	async makeClientCrop(crop) {
		if (this.imageRef && crop.width && crop.height) {
			const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg')
			this.setState({ croppedImageUrl })
		}
	}
	async makeClientCrop2(crop) {
		if (this.imageRef2 && crop.width && crop.height) {
			const croppedImageUrl = await this.getCroppedImg(this.imageRef2, crop, 'newFile.jpeg')
			this.setState({ croppedImageUrl2: croppedImageUrl })
		}
	}

	getCroppedImg(image, crop, fileName) {
		const canvas = document.createElement('canvas')
		const pixelRatio = window.devicePixelRatio
		const scaleX = image.naturalWidth / image.width
		const scaleY = image.naturalHeight / image.height
		const ctx = canvas.getContext('2d')

		canvas.width = crop.width * pixelRatio * scaleX
		canvas.height = crop.height * pixelRatio * scaleY

		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
		ctx.imageSmoothingQuality = 'high'

		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width * scaleX,
			crop.height * scaleY
		)

		return new Promise((resolve, reject) => {
			canvas.toBlob(
				(blob) => {
					if (!blob) {
						//reject(new Error('Canvas is empty'));
						console.error('Canvas is empty')
						return
					}
					blob.name = fileName
					window.URL.revokeObjectURL(this.fileUrl)
					this.fileUrl = window.URL.createObjectURL(blob)
					if (this.state.imageFor == 'mcqImages') {
						this.setState({ mcqCroppedImage: blob })
					} else {
						this.setState({ mcqCardCroppedImage: blob })
					}
					resolve(this.fileUrl)
				},
				'image/jpeg',
				1
			)
		})
	}
	componentDidMount() {
		const { editContent, mcqDetails, contentSelectedLangVal } = this.props
		if (editContent) {
			this.setState({
				mcqTitle: mcqDetails[`mcqTitle_${contentSelectedLangVal}`],
				explanationCardTitle: mcqDetails[`explanationCardTitle_${contentSelectedLangVal}`],
				answerExplanation: mcqDetails[`answerExplanation_${contentSelectedLangVal}`],
				selectedTextColorOption: mcqDetails.textColor ? mcqDetails.textColor : KTColors.white,
				src: mcqDetails.mcqImages ? mcqDetails.mcqImages[0].image : '',
				src2: mcqDetails.mcqCardImages ? mcqDetails.mcqCardImages[0].image : '',
				mcqImages: mcqDetails.mcqImages ? mcqDetails.mcqImages : [],
				mcqCardImages: mcqDetails.mcqCardImages ? mcqDetails.mcqCardImages : [],
				answersInfo: mcqDetails.answersInfo ? mcqDetails.answersInfo : [],
				watchType: mcqDetails.contentLinkDetails ? mcqDetails.contentLinkDetails.watchType : 'Off',
				urlType: mcqDetails.contentLinkDetails
					? mcqDetails.contentLinkDetails.urlType
					: 'Instagram',
				instagramLink: mcqDetails.contentLinkDetails
					? mcqDetails.contentLinkDetails.instagramLink
					: '',
				youtubeLink: mcqDetails.contentLinkDetails ? mcqDetails.contentLinkDetails.youtubeLink : '',
				twitterLink: mcqDetails.contentLinkDetails ? mcqDetails.contentLinkDetails.twitterLink : '',
				websiteLink: mcqDetails.contentLinkDetails ? mcqDetails.contentLinkDetails.websiteLink : '',
				contentNewLinkDetails: mcqDetails.contentNewLinkDetails
					? mcqDetails.contentNewLinkDetails
					: {},
			})
		}
	}
	componentDidUpdate = (prevProps) => {
		if (prevProps.contentSelectedLangVal != this.props.contentSelectedLangVal) {
			const { editContent, mcqDetails, contentSelectedLangVal } = this.props
			if (editContent) {
				this.setState({
					mcqTitle: mcqDetails[`mcqTitle_${contentSelectedLangVal}`],
					explanationCardTitle: mcqDetails[`explanationCardTitle_${contentSelectedLangVal}`],
					answerExplanation: mcqDetails[`answerExplanation_${contentSelectedLangVal}`],
					selectedTextColorOption: mcqDetails.textColor ? mcqDetails.textColor : KTColors.white,
					src: mcqDetails.mcqImages ? mcqDetails.mcqImages[0].image : '',
					src2: mcqDetails.mcqCardImages ? mcqDetails.mcqCardImages[0].image : '',
					mcqImages: mcqDetails.mcqImages ? mcqDetails.mcqImages : [],
					mcqCardImages: mcqDetails.mcqCardImages ? mcqDetails.mcqCardImages : [],
					answersInfo: mcqDetails.answersInfo ? mcqDetails.answersInfo : [],
					watchType: mcqDetails.contentLinkDetails
						? mcqDetails.contentLinkDetails.watchType
						: 'Off',
					urlType: mcqDetails.contentLinkDetails
						? mcqDetails.contentLinkDetails.urlType
						: 'Instagram',
					instagramLink: mcqDetails.contentLinkDetails
						? mcqDetails.contentLinkDetails.instagramLink
						: '',
					youtubeLink: mcqDetails.contentLinkDetails
						? mcqDetails.contentLinkDetails.youtubeLink
						: '',
					twitterLink: mcqDetails.contentLinkDetails
						? mcqDetails.contentLinkDetails.twitterLink
						: '',
					websiteLink: mcqDetails.contentLinkDetails
						? mcqDetails.contentLinkDetails.websiteLink
						: '',
					contentNewLinkDetails: mcqDetails.contentNewLinkDetails
						? mcqDetails.contentNewLinkDetails
						: {},
				})
			}
		}
	}

	renderContentLinkDetails = () => {
		const { urlType, watchType, youtubeLink, instagramLink, twitterLink, websiteLink } = this.state

		return (
			<div>
				<label>Social Media :</label>
				<div style={{ marginRight: 10 }}>
					<input
						value={watchType}
						type='radio'
						checked={watchType == 'Off'}
						onChange={() => {
							this.handleWatchType('Off')
						}}
					></input>
					<text for={'Off'}>{'Off'}</text>
				</div>
				<div style={{ marginRight: 10 }}>
					<input
						value={watchType}
						type='radio'
						checked={watchType == 'watchVideo'}
						onChange={() => {
							this.handleWatchType('watchVideo')
						}}
					></input>
					<text for={'watchVideo'}>{'Watch Video'}</text>
				</div>
				<div style={{ marginRight: 10 }}>
					<input
						value={watchType}
						type='radio'
						checked={watchType == 'visitWebsite'}
						onChange={() => {
							this.handleWatchType('visitWebsite')
						}}
					></input>
					<text for={'visitWebsite'}>{'Visit Website'}</text>
				</div>
				{watchType == 'watchVideo' ? (
					<div>
						<text>{'Watch On : '}</text>
						<div>
							<input
								value={urlType}
								type='radio'
								checked={urlType == 'Instagram'}
								onChange={() => {
									this.handleUrlType('Instagram')
								}}
							></input>
							<text>{'Instagram'}</text>
						</div>
						<div>
							<input
								value={urlType}
								type='radio'
								checked={urlType == 'Youtube'}
								onChange={() => {
									this.handleUrlType('Youtube')
								}}
							></input>
							<text>{'Youtube'}</text>
						</div>
						<div>
							<input
								value={urlType}
								type='radio'
								checked={urlType == 'Twitter'}
								onChange={() => {
									this.handleUrlType('Twitter')
								}}
							></input>
							<text>{'Twitter'}</text>
						</div>
					</div>
				) : null}
				{watchType == 'watchVideo' && urlType == 'Instagram' ? (
					<div>
						<text for='text'>Instagram Link :</text>
						<input
							type='text'
							onChange={(value) => {
								this.handleinstagramLink(value)
							}}
							value={instagramLink}
							placeholder='Please Enter Instagram Link'
						></input>
						{this.handleinstagramLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Instagram Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
				{watchType == 'watchVideo' && urlType == 'Youtube' ? (
					<div>
						<text for='text'>Youtube Link :</text>
						<input
							type='text'
							onChange={(value) => {
								this.handleyoutubeLink(value)
							}}
							value={youtubeLink}
							placeholder='Please Enter Youtube Link'
						></input>
						{this.handleyoutubeLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Youtube Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
				{watchType == 'watchVideo' && urlType == 'Twitter' ? (
					<div>
						<text for='text'>Twitter Link :</text>
						<input
							type='text'
							onChange={(value) => {
								this.handletwitterLink(value)
							}}
							value={twitterLink}
							placeholder='Please Enter Twitter Link'
						></input>
						{this.handletwitterLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Twitter Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
				{watchType == 'visitWebsite' ? (
					<div>
						<text for='text'>Website Link :</text>
						<input
							type='text'
							onChange={(value) => {
								this.handlewebsiteLink(value)
							}}
							value={websiteLink}
							placeholder='Please Enter Website Link'
						></input>
						{this.handlewebsiteLinkError() ? (
							<text for='text' style={{ color: 'red', fontSize: 10 }}>
								Website Link Cannot Be Empty
							</text>
						) : null}
					</div>
				) : null}
			</div>
		)
	}
	renderTitleOptions = () => {
		const { textColorOptions, selectedTextColorOption, contentPosition } = this.state
		return (
			<details>
				<summary>Title Options</summary>
				<div class='justify-content-center' style={{ display: 'flex' }}>
					{textColorOptions.map((item, index) => (
						<div key={index}>
							{selectedTextColorOption == item.value ? (
								<div
									style={{
										backgroundColor: item.value,
										height: 50,
										width: 50,
										marginRight: 5,
										borderColor: 'red',
										borderStyle: 'solid',
									}}
									onClick={() => this.handleTextColorRadioButton(item)}
								></div>
							) : (
								<div
									style={{
										backgroundColor: item.value,
										height: 50,
										width: 50,
										marginRight: 5,
									}}
									onClick={() => this.handleTextColorRadioButton(item)}
								></div>
							)}
						</div>
					))}
				</div>
				<div class='cold-md-12'>
					<input
						type='checkbox'
						onChange={this.handleShowTitleBackground}
						checked={this.state.displayTitleBackground}
					></input>
					<text for='text'> Show Title Background </text>
				</div>
			</details>
		)
	}
	render() {
		const {
			mcqTitle,
			answerExplanation,
			mcqImages,
			mcqCardImages,

			//coverstory images state
			src,
			crop,
			croppedImageUrl,
			cropImage1,
			// cardimages states
			src2,
			crop2,
			croppedImageUrl2,
			cropImage2,
		} = this.state
		const { editContent } = this.props

		return (
			<div>
				<details>
					<summary>MCQ Details</summary>
					<div>
						<div>
							<text>{'title'}</text>
							<input
								type='text'
								onChange={(value) => {
									this.handleTitle(value)
								}}
								value={mcqTitle}
								placeholder='Please Enter  Title'
							></input>
							{this.hastitleError() ? (
								<text for='text' style={{ color: 'red', fontSize: 10 }}>
									Title Cannot Be Empty
								</text>
							) : null}
						</div>
						{/* {this.renderContentLinkDetails()} */}
						<CreateMultiDynamicButtons
							editContent={this.props.editContent}
							contentNewLinkDetails={this.state.contentNewLinkDetails}
							updatecontentNewLinkDetails={this.updatecontentNewLinkDetails}
						/>
						{this.renderTitleOptions()}

						<AnswersInfo
							mcqDetails={this.props.mcqDetails}
							editQuestion={this.props.editQuestion}
							updateAnswersInfo={this.updateAnswersInfo}
							contentSelectedLangVal={this.props.contentSelectedLangVal}
						/>

						<div>
							<p>{'Explanation Title'}</p>
							<textarea
								value={this.state.explanationCardTitle}
								placeholder='Explanation Title'
								onChange={(value) => this.handleExplanationTitle(value)}
							></textarea>
						</div>

						<div>
							<div>
								<text>{'Answer Explanation : '}</text>
							</div>
							<textarea
								onChange={(value) => {
									this.handleAnswerExplanation(value)
								}}
								value={answerExplanation}
								placeholder='Please Enter Answer Explanation'
							></textarea>
							{this.hasAnswerExplanationError() ? (
								<text for='text' style={{ color: 'red', fontSize: 10 }}>
									Please Enter Answer Explanation
								</text>
							) : null}
						</div>
						<div>
							<text for='text'>MCQ Images :</text>

							<p for='text' style={{ color: 'red', fontSize: 10 }}>
								(Only JPG and JPEG images are allowed)
							</p>
							<div>
								<input type='file' accept=".jpg,.jpeg" onChange={this.onSelectFile} />
							</div>

							{cropImage1 && src && !mcqImages.length && (
								<ReactCrop
									src={src}
									crop={crop}
									ruleOfThirds
									onImageLoaded={this.onImageLoaded}
									onComplete={this.onCropComplete}
									onChange={this.onCropChange}
								/>
							)}
							{!cropImage1 ? <img style={{ maxWidth: '100%' }} src={src} /> : null}
							{!mcqImages.length && src && !cropImage1 && (
								<button onClick={() => this.uploadSelectedImage('mcqImages', false)}>
									Upload Image
								</button>
							)}
							{!mcqImages.length && src && !cropImage1 && (
								<button onClick={() => this.setState({ cropImage1: true })}>Crop Image</button>
							)}
							{croppedImageUrl && <img style={{ maxWidth: '100%' }} src={croppedImageUrl} />}
							{src ? (
								<button onClick={() => this.removeSelectedImage('mcqImages')}>Remove Image</button>
							) : null}
							{!mcqImages.length && croppedImageUrl ? (
								<button onClick={() => this.uploadSelectedImage('mcqImages', true)}>
									Upload Cropped Image
								</button>
							) : null}
							{!mcqImages.length ? (
								<text for='text' style={{ color: 'red', fontSize: 10 }}>
									Please Upload Image
								</text>
							) : null}
							<div className='imagesContainer'>
								{mcqImages.map((item, index) => {
									const { copyRightText, copyRight, shareImage, key } = item
									const fullImage = true
									console.log(copyRight, 'copyRight mcq')
									return (
										<div key={index} className='imgPreview'>
											{/* <img src={item.imageValue} />
                        <button onClick={() => this.removeCoverStoryImage(index)}>Remove</button> */}
											<ImageOptions
												item={item}
												copyRight={copyRight}
												copyRightText={copyRightText}
												toggleCopyRightSwitch={(key) => this.toggleCopyRightSwitch(key, fullImage)}
												handleCopyrightText={(key, text) =>
													this.handleCopyrightText(key, text, fullImage)
												}
												handleCopyrightType={(key, copyrightPrefix) =>
													this.handleCopyrightType(key, copyrightPrefix, fullImage)
												}
												shareImage={shareImage}
												toggleShareImageSwitch={(key) =>
													this.toggleShareImageSwitch(key, fullImage)
												}
											/>
										</div>
									)
								})}
							</div>
							<text for='text'>MCQ Card Images :</text>

							<p for='text' style={{ color: 'red', fontSize: 10 }}>
								(Only JPG and JPEG images are allowed)
							</p>
							<div>
								<input type='file' accept=".jpg,.jpeg" onChange={this.onSelectFile2} />
							</div>

							{cropImage2 && src2 && !mcqCardImages.length && (
								<ReactCrop
									src={src2}
									crop={crop2}
									ruleOfThirds
									onImageLoaded={this.onImageLoaded2}
									onComplete={this.onCropComplete2}
									onChange={this.onCropChange2}
								/>
							)}
							{!cropImage2 ? <img style={{ maxWidth: '100%' }} src={src2} /> : null}

							{croppedImageUrl2 && <img style={{ maxWidth: '100%' }} src={croppedImageUrl2} />}

							{!mcqCardImages.length && src2 && !cropImage2 && (
								<button onClick={() => this.uploadSelectedImage('mcqCardImages', false)}>
									Upload Image
								</button>
							)}
							{!mcqCardImages.length && src2 && !cropImage2 && (
								<button onClick={() => this.setState({ cropImage2: true })}>Crop Image</button>
							)}
							{src2 ? (
								<button onClick={() => this.removeSelectedImage()}>Remove Image</button>
							) : null}
							{!mcqCardImages.length && croppedImageUrl2 ? (
								<button onClick={() => this.uploadSelectedImage('mcqCardImages', true)}>
									Upload Cropped Image
								</button>
							) : null}
							{!mcqCardImages.length ? (
								<text for='text' style={{ color: 'red', fontSize: 10 }}>
									Please Upload Image
								</text>
							) : null}
							{mcqCardImages.map((item, index) => {
								const { copyRightText, copyRight, shareImage, key } = item
								const fullImage = false
								return (
									<div key={index} className='imgPreview'>
										<ImageOptions
											item={item}
											copyRight={copyRight}
											copyRightText={copyRightText}
											toggleCopyRightSwitch={(key) => this.toggleCopyRightSwitch(key, fullImage)}
											handleCopyrightText={(key, text) =>
												this.handleCopyrightText(key, text, fullImage)
											}
											handleCopyrightType={(key, copyrightPrefix) =>
												this.handleCopyrightType(key, copyrightPrefix, fullImage)
											}
											shareImage={shareImage}
											toggleShareImageSwitch={(key) => this.toggleShareImageSwitch(key, fullImage)}
										/>
									</div>
								)
							})}
						</div>
					</div>
				</details>
				<label for='text' style={{ color: 'red', fontSize: 10 }}>
					{this.state.imageSizeLimitModal ? "Only JPG,JPEG Images are allowed" : ""}
				</label>
				{/* <Modal show={this.state.imageSizeLimitModal} onHide={() => this.hideImageSizeLimitModal()}>
					<Modal.Body>
						<div className='row'>
							<text>Maximum allowed Image size is {this.state.imageSizeLimit} Kb</text>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.hideImageSizeLimitModal()}>Ok</Button>
					</Modal.Footer>
				</Modal> */}
			</div>
		)
	}
}

export default McqContent
